import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material'
import { IconButton, Stack, TextField, Tooltip, Typography } from '@mui/material'

import { useTexts } from './hooks/useTexts'

import type { BulkLoadPartial } from '../../../../../types'

interface Props {
  load: BulkLoadPartial
  onDeleteLoad: () => void
  onAddLoad: (name: string) => void
  addable?: boolean
  ordersCount: number
  maxLoadsForOrder: number
  disabled?: boolean
}

export function PartialLoad(props: Props) {
  const { load, onDeleteLoad, onAddLoad, ordersCount, addable, maxLoadsForOrder, disabled } = props
  const { name, value } = load

  const texts = useTexts()
  const addDisabled = !addable || disabled

  return (
    <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center">
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="nowrap" width="100%">
        <TextField disabled value={name} label={texts.label} sx={{ minWidth: '120px', flex: 1 }} />
        <Typography variant="body2">{`${value}/${ordersCount}`}</Typography>
      </Stack>
      <Stack direction="row" alignItems="center">
        <Tooltip
          title={
            disabled
              ? texts.fieldDisabled
              : addDisabled
                ? texts.addTooltipDisabled(maxLoadsForOrder)
                : texts.addTooltip
          }
        >
          <span>
            <IconButton
              disabled={addDisabled || disabled}
              color="primary"
              size="small"
              onClick={() => onAddLoad(load.name)}
            >
              <AddCircleOutline />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={disabled ? texts.fieldDisabled : texts.removeTooltip}>
          <span>
            <IconButton color="error" size="small" disabled={disabled} onClick={onDeleteLoad}>
              <RemoveCircleOutline />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>
    </Stack>
  )
}
